import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Build a full image URL from a scene image_url (which is like /api/images/...).
export const imageUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);

export const LANGUAGES = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
];

export const PRESET_CATEGORIES = [
  "Teknoloji",
  "Eğitim",
  "Eğlence",
  "Oyun",
  "Yaşam",
  "Sağlık",
  "Spor",
  "Müzik",
  "Haber",
  "İş & Finans",
  "Yemek",
  "Seyahat",
];

export const DURATION_OPTIONS = [8, 9, 10, 11, 12];

// Channels
export const listChannels = () => client.get("/channels").then((r) => r.data);
export const createChannel = (payload) => client.post("/channels", payload).then((r) => r.data);
export const deleteChannel = (id) => client.delete(`/channels/${id}`).then((r) => r.data);

// Titles
export const listTitles = (channelId) =>
  client.get(`/channels/${channelId}/titles`).then((r) => r.data);
export const generateTitles = (channelId) =>
  client.post(`/channels/${channelId}/generate-titles`).then((r) => r.data);
export const updateTitle = (id, text) =>
  client.patch(`/titles/${id}`, { text }).then((r) => r.data);
export const deleteTitle = (id) => client.delete(`/titles/${id}`).then((r) => r.data);

// Articles
export const listArticles = (channelId) =>
  client.get(`/channels/${channelId}/articles`).then((r) => r.data);
export const getArticle = (id) => client.get(`/articles/${id}`).then((r) => r.data);
export const createArticle = (payload) => client.post("/articles", payload).then((r) => r.data);
export const updateArticle = (id, payload) =>
  client.patch(`/articles/${id}`, payload).then((r) => r.data);
export const deleteArticle = (id) => client.delete(`/articles/${id}`).then((r) => r.data);

// AI Article generation (long: 30-60s)
export const generateArticleBody = (id, duration) =>
  client
    .post(`/articles/${id}/generate-article`, { duration }, { timeout: 180000 })
    .then((r) => r.data);
export const regeneratePart = (id, part_id) =>
  client
    .post(`/articles/${id}/regenerate-part`, { part_id }, { timeout: 120000 })
    .then((r) => r.data);
export const generateScenes = (id) =>
  client.post(`/articles/${id}/generate-scenes`, {}, { timeout: 180000 }).then((r) => r.data);
// Per-scene image generation (avoids proxy edge timeouts). Idempotent: skips if image exists.
export const generateImageForScene = (article_id, scene_id) =>
  client
    .post(`/articles/${article_id}/generate-image/${scene_id}`, {}, { timeout: 120000 })
    .then((r) => r.data);
export const regenerateImage = (article_id, scene_id) =>
  client
    .post(`/articles/${article_id}/regenerate-image/${scene_id}`, {}, { timeout: 120000 })
    .then((r) => r.data);
export const updateScene = (article_id, scene_id, payload) =>
  client
    .patch(`/articles/${article_id}/scenes/${scene_id}`, payload)
    .then((r) => r.data);

// Prompt templates
export const getPromptTemplates = () => client.get("/prompt-templates").then((r) => r.data);
export const updatePromptTemplates = (payload) =>
  client.patch("/prompt-templates", payload).then((r) => r.data);
export const resetPromptTemplates = () =>
  client.post("/prompt-templates/reset").then((r) => r.data);

/** Safely extract a user-facing error message from an axios error. */
export const errMessage = (e, fallback = "İşlem başarısız") => {
  const data = e?.response?.data;
  if (data && typeof data === "object" && typeof data.detail === "string") {
    return data.detail;
  }
  if (typeof e?.message === "string" && !e.message.startsWith("Request failed")) {
    return `${fallback} — ${e.message}`;
  }
  return fallback;
};
